import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const ConferenceBridge = props => (
    <SvgIcon {...props}>
        <path
            d="M3.955 5.301h.028c2.225.003 4.028 1.858 4.03 4.147v.436l.929 2.148a.247.247 0 01-.11.317l-.818.42v1.07c0 .673-.53 1.219-1.186 1.219h-1.66v.938H1.934l.005-.926c.004-.84 0-1.265-.012-1.274C0 12.349 0 10.637 0 8.985c0-1.567.768-2.743 1.927-3.252 1.126-.494 1.703-.435 2.028-.432zM16 5.451v9.103c0 .201-.041.392-.115.566v-.062h-1.66c-.645 0-1.17-.53-1.185-1.19V12.77l-.818-.42a.247.247 0 01-.117-.302l.006-.015.928-2.148v-.436C13.041 7.54 14.294 5.934 16 5.45zm-5.35 1.582A.783.783 0 1110.65 8.6a.783.783 0 01.001-1.566zm-.082-2.391c.928 0 1.807.387 2.397 1.055l.032.036-.685.64a2.202 2.202 0 00-1.744-.834c-.677 0-1.314.298-1.72.803l-.025.032-.684-.64c.59-.691 1.484-1.093 2.429-1.092zm-.041-2.392a5.541 5.541 0 014.16 1.889l.038.043-.692.707a4.582 4.582 0 00-3.506-1.644 4.58 4.58 0 00-3.47 1.601l-.037.043-.692-.707a5.543 5.543 0 014.199-1.932z"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default ConferenceBridge;
